import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './resetPassword.module.css';
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { IoCloseOutline } from "react-icons/io5";
import { logout } from 'services/userLogin/logout';
import ErrorFailed from 'components/errorFailed/errorFailed';
import { updatePassword } from 'services/userLogin/update-password'; 

export default function UpdatePassword() {
    const navigate = useNavigate();
    const location = useLocation();
    const token = new URLSearchParams(location.search).get('token');
    const [password, setPassword] = useState('');
    const [rePassword, setRePassword] = useState('');
    const [error, setError] = useState<string | null>(null);

    const handlePasswordChange = async () => {
        if (password !== rePassword) {
            setError("Die Passwörter stimmen nicht überein.");
            return;
        }

        if (!token) {
            setError("Token ist ungültig oder abgelaufen.");
            return;
        }
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*-_+?&])[A-Za-z\d@$!%*-_+?&]{8,}$/;
        if (!passwordRegex.test(password)) {
            setError(
                "Das Passwort muss mindestens 8 Zeichen lang sein, einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten."
            );
            return;
        }

        try {
            const result = await updatePassword(password,token );  

            if (result.success) {
                setError(null);
                logout(); 
                navigate('/reservierungsportal');  
            } else {
                setError(result.message || "Ein Fehler ist aufgetreten.");
            }
        } catch (error) {
            setError("Fehler beim Setzen des Passworts. Bitte versuchen Sie es erneut.");
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div>
                    <a className={styles.closeButton} onClick={logout} href='/reservierungsportal'>
                        <IoCloseOutline />
                    </a>
                    <h2>Passwort aktualisieren</h2>
                    <p>
                        Bitte geben Sie das neue Passwort ein.
                    </p>
                </div>
            </div>

            <div className={styles.form}>
                {error && <ErrorFailed error={error} />}

                <div className={commonStyles.formGroup}>
                    <label htmlFor="password">Passwort</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="repassword">Passwort wiederholen</label>
                    <input
                        type="password"
                        id="repassword"
                        name="repassword"
                        value={rePassword}
                        onChange={(e) => setRePassword(e.target.value)}
                        required
                    />
                </div>
                <div className={styles.actionButtons}>
                    <button
                        className={`${commonStyles.commonButton} ${commonStyles.backButton}`}
                        onClick={logout}
                    >
                        abbrechen
                    </button>

                    <button
                        className={`${commonStyles.commonButton} ${commonStyles.submitButton}`}
                        onClick={handlePasswordChange} 
                    >
                        Speichern
                    </button>
                </div>
            </div>
        </div>
    );
}
